import { render, staticRenderFns } from "./DeviceStatusReports.vue?vue&type=template&id=47a8b271&scoped=true&"
import script from "./DeviceStatusReports.vue?vue&type=script&lang=js&"
export * from "./DeviceStatusReports.vue?vue&type=script&lang=js&"
import style0 from "./DeviceStatusReports.vue?vue&type=style&index=0&id=47a8b271&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a8b271",
  null
  
)

export default component.exports